module.exports = __webpack_public_path__ + "static/media/rose-cluster.9cdefef1.svg";